export default "__VITE_ASSET__CaBOjAid__"